"use strict";

import InteractionView from "/js/interaction-views/interaction-view.js";
import Strings from "/js/util/strings.js";
import Constants from '/js/core/constants.js';
import Util from '/js/util/util.js';
import FocusUtil from '/js/util/focus-util.js';

/**
 * 
 */
export default class ChecklistInteractionView extends InteractionView {

  #$button;
  #items;  // Array of ChecklistItems

  constructor(data, initialAnswers=null) {
    super(data, initialAnswers);

    const doneText = Strings.get("lesson_ix_listmaker_done");
    const s = `
        <div class="prompt">${ data.subCaption }</div>
        <div id="checklistHolder">
          <div id="checklistItems"></div>
          <div id="checklistButton" class="interaction-big-button" tabindex="${Constants.TABINDEX_CONTENT_GENERAL}">${ doneText }</div>
        </div>`;
    this.$el.append($(s));

    this.#$button = this.$el.find("#checklistButton");
    this.#$button.on('click tap', e => this.#onButton(e));
    FocusUtil.doStandardTreatment(this.#$button);

    const $itemsHolder = this.$el.find("#checklistItems");

    // Init items.
    this.#items = [];
    data.items.forEach((o, index) => {
      const item = new ChecklistItem(o);
      item.isSelected = this.#shouldInitialAnswerBeChecked(initialAnswers, index);
      $itemsHolder.append(item.$el);
      this.#items.push(item);
    });
  }

  /* Override */
  show() {
    super.show();
    setTimeout(
        () => Util.flashMacScrollbar($("#checklistHolder")),
        Constants.generalAnimDuration + 150);
  }

  #shouldInitialAnswerBeChecked(initialAnswers, index) {
    // Answer right-bucket array means selected; left-bucket array means unselected.
    if (!initialAnswers || !initialAnswers.right) {
      return false;
    }
    return (initialAnswers.right.indexOf(index) > -1);
  }

  #onButton(e) {
    // Make the answers.
    this.answers = {
      interactionId: this.data.interactionId,
      type: "leftright",
      left: [],
      right: []
    };
    this.#items.forEach((item, i) => {
      if (item.isSelected) {
        this.answers["right"].push(i);
      } else {
        this.answers["left"].push(i);
      }
    });
    cl('answers:', this.answers);
    this.finish();
  }
}

class ChecklistItem {

  #$el;
  #isSelected = false;

  constructor (data) {
    const s = `
        <div class="item" tabindex="${Constants.TABINDEX_CONTENT_GENERAL}">
          ${data.body}
        </div>`;
    this.#$el = $(s);

    this.#$el.on("click tap", e => this.#onClick(e));
    FocusUtil.doStandardTreatment(this.#$el, true);
  }

  get $el() {
    return this.#$el;
  }

  get isSelected() {
    return this.#isSelected;
  }

  set isSelected(b) {
    this.#isSelected = b;
    this.#$el.removeClass("selected");
    this.#$el.attr("aria-selected", "false");
    if (b) {
      this.#$el.addClass("selected");
      this.#$el.attr("aria-selected", "true");
    }
  }

  #onClick(e) {
    this.isSelected = !this.isSelected;
  }
}
